<div class="bg-background-card-lvl3 flex flex-col gap-2 rounded-2xl border border-text-white p-3">
  <span class="typo-h7-light">{{ 'reason_selector_selected' | translate }}</span>

  <div class="flex flex-wrap gap-2">
    @for (item of items(); track $index) {
      <div
        class="typo-h5-semibold flex items-center gap-1 rounded-lg border border-primary-blue bg-background-light-blue py-[6px] pl-3 pr-[6px]"
      >
        {{ item.abbreviation }}

        <button class="h-4" (click)="deselectItem(item)">
          <svg-icon key="px-16-x" size="sm" class="text-primary-blue"></svg-icon>
        </button>
      </div>
    }
  </div>
</div>
